<template>
  <div v-if="content">
    <v-row>
      <!-- Exercise column -->
      <v-col cols="12">
        <exercise-logic
          :exCollection="$route.meta.model"
          :saveState="saveState"
          @ready="onReady"
          @error="onError"
          @saved="onSaved"
          @savedNext="onSavedNext"
          @loadedEx="onLoadedEx"
          :doc="doc"
          :shared="true"
          :pid="false"
        >
          <template slot-scope="{ saveExercise }">
            <div class="relative">
              <v-row>
                <v-col cols="4" class="mb-4">
                  <h2
                    class="headline"
                    v-text="content[$route.meta.content].step1.title"
                  ></h2>
                </v-col>

                <v-col cols="4" class="">
                  <p
                    v-for="(item, index) in content[$route.meta.content].step1
                      .description"
                    :key="index"
                    v-text="item"
                  />
                  <div class="select d-flex align-center">
                    <span class="mr-4 mb-1">Filter by:</span>
                    <v-select
                      :items="content[$route.meta.content].headers"
                      multiple
                      v-model="filters"
                      item-text="title"
                      item-value="model"
                      required
                    ></v-select>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="doc">
                <v-col cols="12">
                  <timeline-row
                    v-model="doc.years"
                    name="years"
                    :title="content[$route.meta.content].col1"
                    subtitle=""
                    :filters="filters"
                    :content="content[$route.meta.content]"
                    @handleEnd="handleEnd"
                    @autosave="doAutoSave"
                  ></timeline-row>
                </v-col>
              </v-row>
            </div>

            <bottom-navigation
              :save="true"
              :next="false"
              :prev="false"
              :gridView="false"
              :gridToggle="false"
              @save="saveExercise(true)"
            >
            </bottom-navigation>
          </template>
        </exercise-logic>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-card-title class="headline">{{
          content[$route.meta.content].saved.title
        }}</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="amber black--text" text @click="dialog = false">
            Close
          </v-btn>

          <v-btn color="amber accent-1 black--text" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogic } from "@/components/exercises";

import { TimelineRow } from "@/views/user/exercises/timeline";

export default {
  name: "UserTimeline",

  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
  },

  data() {
    return {
      content: null,
      e1: 1,
      exercises: null,
      refs: null,
      dialog: false,
      allItems: null,
      listName: "",
      saveState: false,
      autoSave: true,
      results: {
        items: [],
      },
      doc: {
        years: [],
      },
      list: [],
      listLength: 1,
      debug: false,
      filters: [],
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogic,
    TimelineRow,
  },
  watch: {
    e1(val) {
      if (val === 3) {
        this.createList();
      }
    },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    isAdmin() {
      return this.currentUser.uid === "4jd41CisaJZmDYMwCGMRhFclhXY2";
    },
  },
  mounted() {},

  methods: {
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved ex");
      this.dialog = true;
    },
    onLoadedEx(items) {
      if (items) {
        this.mergeArrays(items.doc);
      }
    },
    onSavedNext() {
      this.saveState = false;
    },
    mergeArrays(arr) {
      console.log("arr", arr);
      this.$set(this.doc, "years", arr.years);
    },
    closeDialog() {
      this.dialog = false;
    },
    handleEnd() {
      this.doAutoSave();
    },
    doAutoSave() {
      if (this.autoSave) {
        console.log("doing autosave");
        this.saveState = true;
      }
    },
  },
};
</script>

<style lang="scss">
.select {
  width: 400px;
}
</style>
